export const SESSION_COPY = {
  loading: '載入中…',
  meUnavailable: '無法連線到伺服器，請稍後再試',
  errorTitle: '無法載入你的帳號資料',
  noAccessTitle: '這個帳號未獲授權',
  noAccessBody: '這個帳號未被加入任何公司，或電郵未完成驗證。請改用其他帳號登入，或聯絡管理員邀請你。',
  retry: '重試',
  pickTenant: '選擇公司',
  pickTenantHint: '你在多間公司有權限，請選擇要處理的佇列',
  switchTenant: '切換公司',
  signOut: '登出',
  roleLabels: { reviewer: '處理人員', approver: '核准人員', admin: '管理員' },
} as const
